import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnDestroy,
} from "@angular/core";
import { Store } from "@ngxs/store";
import { Subscription } from "rxjs";
import { Submodule } from "src/app/interface/user";
import { UserState } from "src/app/states/user.state";

@Directive({
  selector: "[appPermissionButtons]",
})
export class PermissionButtonsDirective implements AfterViewInit, OnDestroy {
  @Input("route") route: string = "";
  @Input("hide") hide = true;
  private originalDisplay: string;
  private sub: Subscription;

  constructor(private store: Store, private el: ElementRef) {}

  ngAfterViewInit(): void {
    this.originalDisplay = getComputedStyle(this.el.nativeElement).display;

    this.sub = this.store
      .select(UserState.submodules)
      .subscribe((submodules) => {
        const module = submodules?.find(
          (m: Submodule) => this.route === m.Route_Submodule
        );

        const hasPermission = module?.Permissions?.length > 0;

        if (!hasPermission) {
          this.el.nativeElement.classList.add("no-permission");

          this.el.nativeElement.addEventListener("click", (e: Event) => {
            e.stopPropagation();
            e.preventDefault();
          });
        }

        if (this.hide) {
          this.el.nativeElement.style.display = hasPermission
            ? this.originalDisplay
            : "none";
        }
      });
  }
  ngOnDestroy(): void {
    if (this.sub) this.sub.unsubscribe();
  }
}
